/**
 * Utility functions for managing MSP view session tracking
 * This prevents users from being repeatedly redirected to msp-view
 * when they have already visited it in their current session
 */

const MSP_VIEW_SESSION_KEY = 'msp_view_visited_session';

/**
 * Mark that the user has visited the msp-view page in the current session
 * This should be called when the msp-view page loads
 */
export const markMspViewVisited = (): void => {
  if (typeof window !== 'undefined') {
    sessionStorage.setItem(MSP_VIEW_SESSION_KEY, 'true');
  }
};

/**
 * Check if the user has visited msp-view in the current session
 * @returns true if msp-view has been visited this session
 */
export const hasVisitedMspView = (): boolean => {
  if (typeof window !== 'undefined') {
    return sessionStorage.getItem(MSP_VIEW_SESSION_KEY) === 'true';
  }
  return false;
};

/**
 * Clear the msp-view session tracking
 * This should be called when the user logs out
 */
export const clearMspViewSession = (): void => {
  if (typeof window !== 'undefined') {
    sessionStorage.removeItem(MSP_VIEW_SESSION_KEY);
  }
};
